module.exports = __webpack_public_path__ + "img/ethereum.a9709f9a.svg";